import React from "react";
import DrawerRemoveObjectComponent from "./DrawerRemoveObjectComponent";
import DrawerGoBackComponent from "./DrawerGoBackComponent";
import { CurrentDrawerOpenType } from "state/slices/RightDrawerSlice";
import CMRSliderComponent, { SliderType } from "./CMRSliderComponent";
import BSUPatientHeader from "./BSUPatientHeader";

const DrawerAnesthesiaComponent = (): JSX.Element => {
    return (
        <>
            <BSUPatientHeader title={"Anesthesia Machine"} />
            <CMRSliderComponent type={SliderType.Anesthesia} title={"Rotate"} />
            <DrawerRemoveObjectComponent
                classes={"mt-35 onlyDesktop"}
                type={"anesthesia"}
                payload={"anesthesia"}
            />
            <DrawerGoBackComponent classes="onlyDesktop" type={CurrentDrawerOpenType.Anesthesia} />
        </>
    );
};

export default DrawerAnesthesiaComponent;
